import React, { Component } from "react";
import { connect } from "react-redux";

//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
import InputIcon    from "../Components/component_IconInput";
import FilterChip   from "../Components/component_FilterChips";
import BuyVersion   from "../Components/component_BuyVersion";
import SGButtonsBar from "../Components/component_SGButtonsBar";
//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import DatePicker                            from "material-ui/DatePicker";
import TextField                             from "material-ui/TextField";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";
//ICON
import IconArrowUp     from "material-ui/svg-icons/navigation/arrow-drop-up";
import IconArrowDown   from "material-ui/svg-icons/navigation/arrow-drop-down";
import IconFilter      from "material-ui/svg-icons/content/filter-list";
import IconEdit        from "material-ui/svg-icons/editor/mode-edit";
import IconAdd         from "material-ui/svg-icons/content/add";
import IconDelete      from "material-ui/svg-icons/action/delete";
import IconShow        from "material-ui/svg-icons/image/remove-red-eye";
import IconRefresh     from "material-ui/svg-icons/navigation/refresh";
//Utils
import * as ROLES      from "../Utils/Roles_Types.js";
import * as STYLES     from "../Utils/Styles.js";
//ACTION
import { getUserInfo } from "../Actions/Action_Authentication";
//ACTION
import {
  getOperatoriList,
  setOperatore,
  orderListaOperatori,
  showAddOperatore,
  hideAddOperatore,
  setUsernameError
} from "../Actions/Action_ServiceRequest_Operatori";
import { getListaAziendeTupla } from "../Actions/Action_ServiceRequest_Azienda";
import { checkUsername, checkEmailService } from "../Actions/Action_ServiceRequest_CheckValue";
import { getHoldingList } from "../Actions/Action_ServiceRequest_Holding";
import PaypalExpressBtn from "react-paypal-express-checkout";
import { paymentConfig, paymentPrices } from "../Actions/Action_ServiceRequest_Pagamento";
import { checkEmail, checkCap, checkNull, checkPivaForm, checkEmailForm, checkCapForm , checkPassword, checkUserLanguage} from "../Utils/Check_Value";
import { LABEL_DIALOG_UserNew_Payment, LABEL_NewUser, LABEL_AssociateUser, LABEL_UsernameValid, LABEL_Required, LABEL_NoResult, LABEL_Enter_ValidUsername, LABEL_Close, LABEL_Cancel, LABEL_Save, LABEL_Enter_Password, LABEL_Password, LABEL_PasswordConfirm, LABEL_OrderBy, LABEL_Yes, LABEL_No, LABEL_Deleted, LABEL_Filter_OnlyLockedUser, LABEL_Filter_OnlyEnabledUser, LABEL_Filter_Either, 
         LABEL_Blocked, LABEL_Information, LABEL_Confirmed, LABEL_NexStep, LABEL_Role, LABEL_Username, LABEL_Enter_Description, LABEL_Enter_Username, LABEL_Email,LABEL_Enter_Email, LABEL_Enter_Phone, LABEL_Phone,
         LABEL_EmailConfirmed, LABEL_Loked, LABEL_All, LABEL_DIALOG_UserModify, LABEL_DIALOG_UserNew, LABEL_PAGE_Operators, LABEL_PasswordNotEquals, LABEL_Choose_Holding, LABEL_Choose_Company, LABEL_Company, LABEL_Holding, LABEL_Filter_OnlyEmailNotConfirmed, LABEL_Filter_OnlyEmailConfirmed   } from "../Utils/Strings/Labels";
import { registerCloudFromUser, registerAssociateCloudUser } from "../Actions/Action_ServiceRequest_Registrazione";

var TIMER = null;

const styles = {
  propContainer: {
    width: 200,
    overflow: "hidden",
    margin: "20px auto 0"
  },
  filterDialog: {
    width: "100%",
    maxWidth: "none"
  },
  filterRow: {
    marginBottom: "20px"
  }
};

const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.ID;
const USERIDAZIENDA = USERINFO == null ? null: USERINFO.Azienda == null ? null : USERINFO.Azienda.ID;
const USERLANGUAGE  = checkUserLanguage(USERINFO);
const CANUSEPAGE    = !(!!USERINFO) ? false :  !(USERINFO.Role.ID === ROLES.ACCOUNT_FREE_ID || USERINFO.Role.ID === ROLES.ACCOUNT_PRO_ID);

const emptyUserModel = {
	IDAzienda : null,
	IDRole    : null,
	Holding   : {
		ID : null
	},
	Telefono : null,
	Pagamento : null,
	Username : null,
	Password : null,
	ConfirmPassword : null,
	Email : null
}

class Operatori extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //Table
      fixedHeader         : true,
      fixedFooter         : true,
      stripedRows         : false,
      showRowHover        : true,
      selectable          : true,
      multiSelectable     : false,
      enableSelectAll     : false,
      deselectOnClickaway : false,
      showCheckboxes      : false,
      height              : "500px",
      selectedList        : [],
      //Ordinamento
      ordinaPer  : null,
      filter : {
        LockoutEnabled : null, 
        EmailConfirmed : null, 
        Email          : null, 
        Username       : null,
        PhoneNumber    : null,
        IDHolding      : USERIDHOLDING,
        IDAzienda      : USERIDAZIENDA,
        IDRole         : null
      },
      filterDialog : {
        opened : false,
        data : null     //Lo utilizzo per salvare i movimenti nella dialog cosi che se vengono annullati rimane tutto come prima
      },
      showAddModify : {
        opened: false,
        data : JSON.parse(JSON.stringify(emptyUserModel)),
        cheked : false
      },
      filterHolding : {
        ID : null,
        Nome : null,
        Descrizione : null,
        DataInizioScadenza : null,
        DataFineScadenza : null
      },
      paid : {
        success: false,
        error  : false,
        toDo   : true
      },
      payment : null,
      money : {
        currency : 'EUR', //'USD'    , // or you can set this value from your props or state
        total    : 0.01 , // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout
        selected : false,
        obj      : null
      },
      filterChipsList : []
    }
  }

  isSelectedRow      = index => this.state.selectedList.indexOf(index) !== -1;
  handleRowSelection = row   => this.setState({ selectedList : row });

  setTimerForText = () => {
    if(TIMER != null)
      clearTimeout(TIMER);
    TIMER = setTimeout(() => {
      this.props.dispatch(getOperatoriList(this.state.filter));
    }, 500);
  }

  //Per intercettare il cambio di filtri testuali
  handleOnFilterTextChange = (value, position, label) => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[position] = value;
    filterChips[position] = {position : position, value : value, label : label };
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  };

  handleDeleteButton = () =>{
    if(this.state.selectedList[0] > this.props.operatoriList.length){
      this.setState({selectedList : []});
      return;
    }
    var showAddModify = this.props.operatoriList[this.state.selectedList[0]];
    showAddModify.LockoutEnabled = true;
    if (this.state.selectedList[0] == this.props.operatoriList.length -1) // se era l'ultimo
      this.setState({ selectedList: [] });
    //this.props.dispatch(setOperatore(showAddModify));
  }
  //FILTER DIALOG
  handleOpenFilterDialog = () => {
    var filterDialog = this.state.filterDialog;
    filterDialog.opened = true;
    filterDialog.data = JSON.parse(JSON.stringify(this.state.filter));
    filterDialog.data.LockoutEnabled = filterDialog.data.LockoutEnabled === null ? -1 : Number(filterDialog.data.LockoutEnabled);
    filterDialog.data.EmailConfirmed = filterDialog.data.EmailConfirmed === null ? -1 : Number(filterDialog.data.EmailConfirmed);    
    this.setState({ filterDialog: filterDialog });
  };
  handleCloseFilterDialog = () => {
    var filterDialog    = this.state.filterDialog;
    filterDialog.opened = false;
    filterDialog.data   = null;
    this.setState({filterDialog : filterDialog});
  };
  handleCloseFilterDialogWithSave = () => {
    var filterDialog                 = this.state.filterDialog;
    filterDialog.opened              = false;
    filterDialog.data.LockoutEnabled = filterDialog.data.LockoutEnabled == -1 ? null : !!filterDialog.data.LockoutEnabled;
    filterDialog.data.EmailConfirmed = filterDialog.data.EmailConfirmed == -1 ? null : !!filterDialog.data.EmailConfirmed;
    filterDialog.data.Cancellato     = filterDialog.data.Cancellato     == -1 ? null : !!filterDialog.data.Cancellato;
    this.setState({filter : filterDialog.data});
    this.props.dispatch(getOperatoriList(filterDialog.data));
  };
  //Funzione per l'evento nel toggle dei filtri
  handleFilterToggle = (event, toggle, position, label) => {
    var filterChips             = this.state.filterChipsList;
    var filterDialog            = this.state.filterDialog;
    filterDialog.data[position] = toggle;
    filterChips[position]       = {position : position, value : toggle, label : label };
    this.setState({filterDialog : filterDialog, filterChipsList : filterChips});
  }

  handleOrderChange = (event, index, value) => {
    this.setState( { ordinaPer : value } );
    this.props.dispatch(orderListaOperatori(this.props.operatoriList, value))
  }
  
  handleFilterHoldingChange = (event, index, value) => {
    var filterDialog = this.state.filterDialog;
    filterDialog.data.IDHolding = value;
    this.setState({ filterDialog: filterDialog });
    this.props.dispatch(getListaAziendeTupla(USERINFO == null ? null : USERINFO.Holding == null ? null : USERINFO.Holding.ID));
  }

  handleFilterAziendaChange = (event, index, value, label) => {
    var filterDialog = this.state.filterDialog;
    filterDialog.data.IDAzienda = value;
    this.setState({ filterDialog: filterDialog });
  }
  
  //ADDMODIFY
  handleOpenAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.cheked = false;
    if(this.state.selectedList.length == 1){
      showAddModify.data = JSON.parse(JSON.stringify(this.props.operatoriList[this.state.selectedList[0]]));
    }else{
      showAddModify.data = JSON.parse(JSON.stringify(emptyUserModel));
      showAddModify.data.IDHolding = USERINFO.Holding == null ? null : USERINFO.Holding.ID;
      showAddModify.data.IDAzienda = USERINFO.Azienda == null ? null : USERINFO.Azienda.ID;
      showAddModify.data.IDRole = null;
      showAddModify.data.NewUser = true;
      if(showAddModify.data.IDHolding != null && showAddModify.data.IDAzienda == null)
        this.props.dispatch(getListaAziendeTupla(showAddModify.data.IDHolding));
    }
    this.props.dispatch(showAddOperatore());
    this.setState({showAddModify : showAddModify});
  }
  handleCloseAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = false;
    this.setState( { showAddModify : showAddModify } );
    this.props.dispatch(hideAddOperatore());
  }
  handleCloseAddModifyWithSave = () => {
    //Controllo i campi
    var flag = true;
    var showAddModify = this.state.showAddModify;
    var data = showAddModify.data;
    var newUser = data.NewUser;
    if( showAddModify.cheked ){
      return;
    }
    
    if( newUser && checkNull( data.Username ) ){
      data.msgErrorUsername = LABEL_Required[USERLANGUAGE];
      flag = false;
    }else if( newUser && !checkNull( this.props.usernameError ) ) flag = false;
    else data.msgErrorUsername = null;

    if( !newUser && !checkNull( this.props.usernameAssociaError ) ){ //controllo se e' un utente gia utilizzato
       if(this.props.usernameAssociaError !== LABEL_UsernameValid[USERLANGUAGE]){
         flag = false;
       }
    }else data.msgErrorAssociaUsername = LABEL_Enter_ValidUsername[USERLANGUAGE];

    data.msgErrorEmail = checkEmailForm( data.Email );
    if ( newUser && data.msgErrorEmail != null ){
      flag = false;
    }else if( newUser && !checkNull( this.props.userEmailError ) ) flag = false;
    
    else data.msgErrorEmail = null;

    if ( checkNull( data.IDRole ) ){
      data.msgErrorRuolo = LABEL_Required[USERLANGUAGE];
      flag = false;
    } else data.msgErrorRuolo = null;

    if ( checkNull( data.IDAzienda ) ){
      data.msgErrorAzienda = LABEL_Required[USERLANGUAGE];
      flag = false;
    } else data.msgErrorAzienda = null;

    if ( newUser && checkNull( data.Password ) ){
      data.msgErrorPassword = LABEL_Required[USERLANGUAGE];
      flag = false;
    } else data.msgErrorPassword = null;

    if ( newUser && checkNull( data.ConfirmPassword ) ){
      data.msgErrorConfirmPassword = LABEL_Required[USERLANGUAGE];
      flag = false;
    } else data.msgErrorConfirmPassword = null;

    
    if( newUser && data.Password !== data.ConfirmPassword){
      data.msgErrorConfirmPassword = data.msgErrorPassword = LABEL_PasswordNotEquals[USERLANGUAGE];
      flag = false;
    }else if( newUser ){
      var err = checkPassword(data.Password);
      data.msgErrorConfirmPassword = data.msgErrorPassword = err;
      if( err != null ) flag = false;
    }

    showAddModify.data = data;
    if(flag)
      showAddModify.cheked = true;
    this.setState( { showAddModify : showAddModify } );
  }
  handleOnChangeAddModifyText = (value, position) => {
    var showAddModify = this.state.showAddModify;
    if(value == null || value.trim() == ""){
      showAddModify.data["msgError"+position] = LABEL_Required[USERLANGUAGE];
    }else showAddModify.data["msgError"+position] = "";
    showAddModify.data[position] = value;
    if ( position === "Username" || position === 'AssociaUsername') {
      this.props.dispatch(checkUsername(showAddModify.data[position]));
    }
    if ( position == "Email" ) {
      this.props.dispatch(checkEmailService(showAddModify.data[position]));
    }
    this.setState( { showAddModify : showAddModify } );
  }
  handleAddModifyUserType = (event, index, value) => {
    var showAddModify          = this.state.showAddModify;
    showAddModify.data.NewUser = value;
    this.props.dispatch(checkUsername( value ? showAddModify.data["Username"] : showAddModify.data["AsociaUsername"]));
    this.setState({ showAddModify: showAddModify });
  }
  handleAddModifyHoldingChange = (event, index, value) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.IDHolding = value;
    showAddModify.data.IDAzienda = null;
    showAddModify.data.IDRole   = null;
    this.setState({ showAddModify: showAddModify });
    this.props.dispatch(getListaAziendeTupla(USERINFO == null ? null : USERINFO.Holding == null ? null : USERINFO.Holding.ID));
  }
  handleAddModifyAziendaChange = (event, index, value) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.IDAzienda = value;
    showAddModify.data.IDRole   = null;
    showAddModify.data.msgErrorAzienda = !checkNull(value) ? null : LABEL_Required[USERLANGUAGE];
    this.setState({ showAddModify: showAddModify });
  }
  handleAddModifyRoleChange = (event, index, value) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.IDRole = value;
    showAddModify.data.msgErrorRole = !checkNull(value) ? null : LABEL_Required[USERLANGUAGE];
    this.setState({ showAddModify: showAddModify });
  }

  componentDidMount = () => {
    if(!CANUSEPAGE) return;
    if(USERINFO.Role.ID === ROLES.ADMINISTRATOR_IS_ID || USERINFO.Holding!=null)
    this.props.dispatch(getOperatoriList(this.state.filter));
    //se e' un amministratore is visualizzo prima la holding da selezionare poi la lista aziende
    if (USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID){
      //richiedo la lista delle holding
      this.props.dispatch(getHoldingList(this.state.filterHolding));
    }else if(USERINFO.Role.ID == ROLES.ADMINISTRATOR_HOLDING_ID){
      //richiedo la lista delle aziende (potendo visualizzare solo quelle)
      this.props.dispatch(getListaAziendeTupla(USERINFO == null ? null : USERINFO.Holding == null ? null : USERINFO.Holding.ID));
    }
    
    this.props.dispatch(paymentConfig());
    this.props.dispatch(paymentPrices());
  }

  onPaymentError = err =>{
    var paid  = this.state.paid;
    paid.toDo    = false;
    paid.success = false;
    paid.erro    = true;
    this.setState({paid: paid});
  }

  onPaymentSuccess = payment =>{
    var paid = this.state.paid;
    paid.toDo    = false;
    paid.success = true;

    if(this.state.showAddModify.data.NewUser)
      this.props.dispatch(registerCloudFromUser(this.state.showAddModify.data, payment));
    else
      this.props.dispatch(registerAssociateCloudUser(this.state.showAddModify.data, payment, USERIDHOLDING));
    this.props.dispatch(hideAddOperatore());
    this.setState({ paid: paid, payment: payment , showAddModify : {opened : false, data : {} }});
    setTimeout( () => this.props.dispatch(getOperatoriList(this.state.filter) ), 150);
  }

  onPaymentCancel = cancel =>{

  }

  onDeleteChips = chip => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[chip.position] = null;
    filterChips[chip.position] = null;
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  }

  
  
  render() {
    if(this.props.toRefreshOnRender)
      this.props.dispatch(getOperatoriList(this.state.filter));

    //Tasti per la dialog filtri
    const filterDialogAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseFilterDialog}
      />,
      <RaisedButton
        label={LABEL_Save[USERLANGUAGE]}
        primary={true}
        onClick={this.handleCloseFilterDialogWithSave}
      />
    ];

    const addModifyDialogAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseAddModify}
      />,
      <RaisedButton
        label={!this.state.showAddModify.cheked ? LABEL_NexStep[USERLANGUAGE] : LABEL_Close[USERLANGUAGE]}
        primary={true}
        onClick={this.handleCloseAddModifyWithSave}
      />
    ];

    var buttonBarList = [];
    if(USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID || USERINFO.Role.ID == ROLES.ADMINISTRATOR_HOLDING_ID){
      buttonBarList = [
        { //AGGIUNGI
          icon     : <IconAdd />, 
          onClick  : this.handleOpenAddModify,
          disabled : this.state.selectedList.length > 0 ,
        }
      ]
    }
    buttonBarList.push({ //REFRESH
      icon     : <IconRefresh />, 
      onClick  : () => this.props.dispatch(getOperatoriList(this.state.filter))
    });

    return <div>
        <Menu 
          dispatch={this.props.dispatch}
          pageName={LABEL_PAGE_Operators[USERLANGUAGE]}
          rightNavButtonIcon={!CANUSEPAGE ? null : <IconFilter/>}
          rightNavButtonFunction={this.handleOpenFilterDialog} Language={USERLANGUAGE}/>

        <Loader isFetching={this.props.isFetching}/>
        <ErrorMessage message={this.props.errorMessage} />
          <BuyVersion 
            visible={!CANUSEPAGE}
            Language={USERLANGUAGE}/>
        <div className="my-body">
          <Grid>
              <Row style={styles.filterRow}>
                <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                    <InputIcon
                        icon              = {<IconFilter/>}
                        className         = "input-label"
                        onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Username", LABEL_Username[USERLANGUAGE] ) }
                        hintText          = { LABEL_Enter_Username[USERLANGUAGE] }
                        floatingLabelText = { LABEL_Username[USERLANGUAGE]       }
                        value             = { this.state.filter.Username == null ? "" : this.state.filter.Username}/>
                </Col>
                <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                    <InputIcon
                        icon              = {<IconFilter/>}
                        className         = "input-label"
                        onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Email", LABEL_Email[USERLANGUAGE]) }
                        hintText          = { LABEL_Enter_Email[USERLANGUAGE] }
                        floatingLabelText = { LABEL_Email[USERLANGUAGE]       }
                        value             = { this.state.filter.Email == null ? "" : this.state.filter.Email}/>
                </Col>
                <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                    <InputIcon
                        icon              = {<IconFilter/>}
                        className         = "input-label"
                        onChange          = { event => this.handleOnFilterTextChange( event.target.value, "PhoneNumber", LABEL_Phone[USERLANGUAGE] ) }
                        hintText          = { LABEL_Enter_Phone[USERLANGUAGE]}
                        floatingLabelText = { LABEL_Phone[USERLANGUAGE]}
                        value             = { this.state.filter.PhoneNumber == null ? "" : this.state.filter.PhoneNumber}/>
                </Col>
                <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                 <SelectField
                      floatingLabelText={LABEL_OrderBy[USERLANGUAGE]}
                      value={this.state.ordinaPer}
                      onChange={this.handleOrderChange}
                    >
                      <MenuItem value={"Cancellata"}     primaryText = { LABEL_Deleted[USERLANGUAGE] } rightIcon = { <IconArrowUp />}/>
                      <MenuItem value={"CancellataDESC"} primaryText = { LABEL_Deleted[USERLANGUAGE] } rightIcon = { <IconArrowDown />}/>
                      <MenuItem value={"Email"}          primaryText = { LABEL_Email[USERLANGUAGE]   } rightIcon = { <IconArrowUp />}/>
                      <MenuItem value={"EmailDESC"}      primaryText = { LABEL_Email[USERLANGUAGE]   } rightIcon = { <IconArrowDown />}/>
                      <MenuItem value={"Role"}           primaryText = { LABEL_Role[USERLANGUAGE]    } rightIcon = { <IconArrowUp />}/>
                      <MenuItem value={"RoleDESC"}       primaryText = { LABEL_Role[USERLANGUAGE]    } rightIcon = { <IconArrowDown />}/>
                      <MenuItem value={"Telefono"}       primaryText = { LABEL_Phone[USERLANGUAGE]   } rightIcon = { <IconArrowUp />}/>
                      <MenuItem value={"TelefonoDESC"}   primaryText = { LABEL_Phone[USERLANGUAGE]   } rightIcon = { <IconArrowDown />}/>
                      <MenuItem value={"Username"}       primaryText = { LABEL_Username[USERLANGUAGE]} rightIcon = { <IconArrowUp />}/>
                      <MenuItem value={"UsernameDESC"}   primaryText = { LABEL_Username[USERLANGUAGE]} rightIcon = { <IconArrowDown />}/>
                    </SelectField>
                </Col>
              </Row>
              {USERINFO != null && <Row>
                      <SGButtonsBar list={buttonBarList}/>
                  { /*MODIFICA
                    USERINFO.Role.ID != ROLES.OPERATOR_ID &&
                    <Col sm12={1}>
                      <RaisedButton 
                        className="button-table" 
                        icon={<IconEdit />} 
                        onClick={this.handleOpenAddModify}
                        disabled={this.state.selectedList.length !== 1}/>
                    </Col>*/
                  }
                  { /*ELIMINA
                    USERINFO.Role.ID != ROLES.OPERATOR_ID &&
                    <Col sm12={1}>
                      <RaisedButton 
                        className="button-table" 
                        icon={<IconDelete />} 
                        onClick={this.handleDeleteButton}
                        disabled={this.state.selectedList.length < 1 }/>
                    </Col>*/
                  }
                  { /*VISUALIZZA DETTAGLIO
                    <Col sm12={1}>
                      <RaisedButton 
                        className="button-table" 
                        icon={<IconShow />} 
                        onClick={this.handleOpenShowDetails}
                        disabled={this.state.selectedList.length !== 1}/>
                    </Col>*/
                  }
                  
              </Row>}
            </Grid>

          <FilterChip
            list = {this.state.filterChipsList}
            onDelete = {this.onDeleteChips}
          />

          <Table
            className       = "shadow"
            height          = { (window.innerHeight -500 )+"px" }
            fixedHeader     = { this.state.fixedHeader}
            fixedFooter     = { this.state.fixedFooter}
            selectable      = { this.state.selectable}
            multiSelectable = { this.state.multiSelectable}
            onRowSelection  = { this.handleRowSelection} >

              <TableHeader
                displaySelectAll  = { this.state.showCheckboxes  }
                adjustForCheckbox = { this.state.showCheckboxes  }
                enableSelectAll   = { this.state.enableSelectAll }>
                <TableRow>
                  <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_Username[USERLANGUAGE]}  </TableHeaderColumn>
                  <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_Email[USERLANGUAGE]}     </TableHeaderColumn>
                  <TableHeaderColumn style={{width: "5%"}}  tooltip="">{LABEL_Phone[USERLANGUAGE]}     </TableHeaderColumn>
                  <TableHeaderColumn style={{width: "5%"}}  tooltip="">{LABEL_Blocked[USERLANGUAGE]}   </TableHeaderColumn>
                  <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_Company[USERLANGUAGE]}   </TableHeaderColumn>
                  <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_Holding[USERLANGUAGE]}   </TableHeaderColumn>
                  <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_Role[USERLANGUAGE]}      </TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody
                displayRowCheckbox  = {this.state.showCheckboxes}
                deselectOnClickaway = {this.state.deselectOnClickaway}
                showRowHover        = {this.state.showRowHover}
                stripedRows         = {this.state.stripedRows}
              >
                { this.props.operatoriList != null &&
                  this.props.operatoriList.map( (row, index) => (
                    <TableRow key={index} selected={this.isSelectedRow(index)}>
                    <TableRowColumn style={{width: "10%"}} > { row.Username       }                                                       </TableRowColumn>
                    <TableRowColumn style={{width: "10%"}} > { row.Email          }                                                       </TableRowColumn>
                    <TableRowColumn style={{width: "5%"}}  > { row.PhoneNumber == null || row.PhoneNumber == "" ? "-" : row.PhoneNumber } </TableRowColumn>
                    <TableRowColumn style={{width: "5%"}}  > { row.LockoutEnabled ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE] }    </TableRowColumn>
                    <TableRowColumn style={{width: "10%"}} > { row.Azienda != null ? row.Azienda.Nome : "-" }                             </TableRowColumn>
                    <TableRowColumn style={{width: "10%"}} > { row.Holding != null ? row.Holding.Nome : "-" }                             </TableRowColumn>
                    <TableRowColumn style={{width: "10%"}} > { row.Role    != null ? row.Role.Nome    : "-" }                             </TableRowColumn>
                    </TableRow>
                  ))
                }
                { this.props.operatoriList != null &&
                  this.props.operatoriList.length == 0 &&
                  <TableRow selectable={false} hoverable={false} hovered={false} selectable={false} striped={false}>
                  <TableRowColumn><center>Nessun Risultato</center></TableRowColumn>
                  </TableRow>
                }
                
              </TableBody>
          </Table>

          <Dialog
            title={"Filtri"}
            actions={filterDialogAction}
            modal={true}
            contentStyle={styles.filterDialog}
            open={this.state.filterDialog.opened} >
              <Grid>
                { USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID &&
                  <Row>
                    <Col sm12={2}><div className="margin-top-25px">{LABEL_Holding[USERLANGUAGE]}</div></Col>
                    <Col sm12={3}>
                    <SelectField 
                        floatingLabelText={LABEL_Choose_Holding[USERLANGUAGE]}
                        value    = {this.state.filterDialog.data == null ? "": this.state.filterDialog.data.IDHolding}
                        onChange = {this.handleFilterHoldingChange}>
                          { 
                            this.props.holdingList && this.props.holdingList.map( holding => <MenuItem key={holding.ID} value={holding.ID} primaryText={holding.Nome}/>  )
                          }
                    </SelectField>
                    </Col>
                  </Row>}
                { ( ( USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID || USERINFO.Role.ID == ROLES.ADMINISTRATOR_HOLDING_ID ) && (this.state.filterDialog.data != null && this.state.filterDialog.data.IDHolding )  ) &&
                  <Row>
                    <Col sm12={2}><div className="margin-top-25px">{LABEL_Company[USERLANGUAGE]}</div></Col>
                    <Col sm12={3}>
                      <SelectField 
                          floatingLabelText={LABEL_Choose_Company[USERLANGUAGE]}
                          value    = {this.state.filterDialog.data == null ? "": this.state.filterDialog.data.IDAzienda}
                          onChange = {(event, index, value) => this.handleFilterAziendaChange(event, index, value, LABEL_Company[USERLANGUAGE])}>
                            { 
                              this.props.aziendeList && this.props.aziendeList.map( azienda => <MenuItem key={azienda.ID} value={azienda.ID} primaryText={azienda.Nome}/>  )
                            }
                      </SelectField>
                    </Col>
                  </Row>}
                <Row  className="margin-top-25px">
                  <Col sm12={2}>
                    <div>{LABEL_EmailConfirmed[USERLANGUAGE]}</div>
                  </Col>
                  <Col sm12={3} className="line-bottom"> 
                    <RadioButtonGroup name="shipSpeed"
                      defaultSelected={this.state.filterDialog.data === null ? -1 : this.state.filterDialog.data.EmailConfirmed}
                      onChange={(event, toggle) => this.handleFilterToggle(event, toggle, "EmailConfirmed", LABEL_EmailConfirmed[USERLANGUAGE])} >
                      <RadioButton value={1}  label={LABEL_Yes[USERLANGUAGE]} />
                      <RadioButton value={0}  label={LABEL_No[USERLANGUAGE]}  />
                      <RadioButton value={-1} label={LABEL_All[USERLANGUAGE]} />
                    </RadioButtonGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm12={2}>
                    <div>{LABEL_Loked[USERLANGUAGE]}</div>
                  </Col>
                  <Col sm12={3} className="line-bottom">
                    <RadioButtonGroup name="shipSpeed" 
                      defaultSelected={this.state.filterDialog.data === null ? -1 : this.state.filterDialog.data.LockoutEnabled} 
                      onChange={(event, toggle) => this.handleFilterToggle(event, toggle, "LockoutEnabled", LABEL_Loked[USERLANGUAGE])} >
                      <RadioButton value={0}  label={LABEL_Yes[USERLANGUAGE]} />
                      <RadioButton value={1}  label={LABEL_No[USERLANGUAGE]}  />
                      <RadioButton value={-1} label={LABEL_All[USERLANGUAGE]} />
                    </RadioButtonGroup>
                  </Col>
                </Row>
              </Grid>
          </Dialog>

          {/*Dialog Aggiungi*/}
          <Dialog
              title={this.state.selectedList.length == 0 ? LABEL_DIALOG_UserNew[USERLANGUAGE] : LABEL_DIALOG_UserModify[USERLANGUAGE]}
              actions={addModifyDialogAction}
              modal={true}
              contentStyle={styles.filterDialog}
              open={this.props.showAddOperatoreDialog}
              autoScrollBodyContent={false}
            >
            {!this.state.showAddModify.cheked && 
              <Grid>
                <Row>
                  <Col sm12={6}>
                    <SelectField
                      floatingLabelText={LABEL_Choose_Holding[USERLANGUAGE]}
                      value={this.state.showAddModify.data.NewUser}
                      onChange={this.handleAddModifyUserType}>
                        <MenuItem value = { true  } primaryText = { LABEL_NewUser[USERLANGUAGE]       } />
                        <MenuItem value = { false } primaryText = { LABEL_AssociateUser[USERLANGUAGE] } />
                    </SelectField>
                  </Col>
                  
                </Row>
                <Row><p className="subheader-dialog">{LABEL_Information[USERLANGUAGE]}</p></Row>
                
                { this.state.showAddModify.data.NewUser === false && //ASSOCIA UTENTE
                  <Row>
                    <Col sm12={6}>
                      <TextField 
                          className         = "input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText( event.target.value, "AssociaUsername" ) }
                          hintText          = {LABEL_Enter_Username[USERLANGUAGE]}
                          floatingLabelText = {LABEL_Username[USERLANGUAGE]}
                          errorText         = {this.state.showAddModify.data.msgErrorAssociaUsername || this.props.usernameAssociaError}
                          errorStyle        = {{color: "green"}}
                          value             = {this.state.showAddModify.data == null ? "" : this.state.showAddModify.data.AssociaUsername}/>
                    </Col>
                  </Row>
                }
                
                { this.state.showAddModify.data.NewUser === true && //NUOVO UTENTE
                  <Row>
                    <Col sm12={6}>
                      <TextField 
                          className         = "input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText( event.target.value, "Username" ) }
                          hintText          = {LABEL_Enter_Username[USERLANGUAGE]}
                          floatingLabelText = {LABEL_Username[USERLANGUAGE]}
                          errorText         = {this.state.showAddModify.data.msgErrorUsername || this.props.usernameError}
                          value             = {this.state.showAddModify.data == null ? "" : this.state.showAddModify.data.Username}/>
                    </Col>
                    <Col sm12={6}>
                      <TextField 
                          className         = "input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText( event.target.value, "Email" ) }
                          hintText          = {LABEL_Enter_Email[USERLANGUAGE]}
                          floatingLabelText = {LABEL_Email[USERLANGUAGE]}
                          errorText         = {this.state.showAddModify.data.msgErrorEmail || this.props.userEmailError}
                          value             = {this.state.showAddModify.data == null ? "" : this.state.showAddModify.data.Email}/>
                    </Col>
                  </Row>
                }

                { this.state.showAddModify.data.NewUser === true && //NUOVO UTENTE
                  <Row>
                    <Col sm12={6}>
                      <TextField 
                          className         = "input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText( event.target.value, "Password" ) }
                          hintText          = {LABEL_Enter_Password[USERLANGUAGE]}
                          floatingLabelText = {LABEL_Password[USERLANGUAGE]}
                          type              = "password"
                          errorText         = {this.state.showAddModify.data.msgErrorPassword || this.props.errorAddOperatorePassword}
                          value             = {this.state.showAddModify.data == null ? "" : this.state.showAddModify.data.Password}/>
                    </Col>
                    <Col sm12={6}>
                      <TextField 
                          className         = "input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText( event.target.value, "ConfirmPassword" ) }
                          hintText          = {LABEL_Enter_Password[USERLANGUAGE]}
                          floatingLabelText = {LABEL_PasswordConfirm[USERLANGUAGE]}
                          type              = "password"
                          errorText         = {this.state.showAddModify.data.msgErrorConfirmPassword || this.props.errorAddOperatoreConfirmPassword}
                          value             = {this.state.showAddModify.data == null ? "" : this.state.showAddModify.data.ConfirmPassword}/>
                    </Col>
                  </Row>
                }
                
                
                <Row><p className="subheader-dialog">{LABEL_Company[USERLANGUAGE]}</p></Row>
                <Row>
                      { USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID &&
                  <Col sm12={6}>
                        <SelectField
                          floatingLabelText={LABEL_Choose_Holding[USERLANGUAGE]}
                          value={this.state.showAddModify.data == null ? null: this.state.showAddModify.data.IDHolding}
                          onChange={this.handleAddModifyHoldingChange}
                          disabled={USERINFO.Role.ID != ROLES.ADMINISTRATOR_IS_ID}>
                            <MenuItem value={null} primaryText={""}/>
                            { this.props.holdingList && this.props.holdingList.map( holding => <MenuItem key={holding.ID} value={holding.ID} primaryText={holding.Nome}/>  ) }
                        </SelectField>
                  </Col>}
                  { ( ( USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID || USERINFO.Role.ID == ROLES.ADMINISTRATOR_HOLDING_ID ) && (this.state.showAddModify.data != null && this.state.showAddModify.data.IDHolding )  ) &&
                    <Col sm12={6}>
                      <SelectField
                          floatingLabelText={LABEL_Choose_Company[USERLANGUAGE]}
                          value={this.state.showAddModify.data == null ? null: this.state.showAddModify.data.IDAzienda}
                          onChange={this.handleAddModifyAziendaChange}
                          errorText={this.state.showAddModify.data.msgErrorAzienda}
                          disabled={USERINFO.Role.ID == ROLES.ADMINISTRATOR_AZIENDA_ID || USERINFO.Role.ID == ROLES.OPERATOR_ID}>
                            <MenuItem value={null} primaryText={""}/>
                            {  this.props.aziendeList && this.props.aziendeList.map( azienda => <MenuItem key={azienda.ID} value={azienda.ID} primaryText={azienda.Nome}/>  ) }
                      </SelectField>
                    </Col>}
                </Row>

                <Row><p className="subheader-dialog">{LABEL_Role[USERLANGUAGE]}</p></Row>
                <Row>
                  <Col sm12={6}>
                    <SelectField 
                        floatingLabelText={LABEL_Role[USERLANGUAGE]}
                        value={this.state.showAddModify.data == null ? null : this.state.showAddModify.data.IDRole}
                        onChange={this.handleAddModifyRoleChange}
                        errorText={this.state.showAddModify.data.msgErrorRuolo}>
                          { USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID && this.state.showAddModify.data.IDHolding == null && this.state.showAddModify.data.IDAzienda == null &&
                            <MenuItem value={ROLES.ADMINISTRATOR_IS_ID}   primaryText={ROLES.ADMINISTRATOR_IS_NOME}/>}
                          { USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID && this.state.showAddModify.data.IDHolding != null && this.state.showAddModify.data.IDAzienda == null &&
                            <MenuItem value={ROLES.ADMINISTRATOR_HOLDING_ID}   primaryText={ROLES.ADMINISTRATOR_HOLDING_NOME}/>}
                          { 
                            ( this.state.showAddModify.data.IDHolding != null && this.state.showAddModify.data.IDAzienda != null) &&
                            ( USERINFO.Role.ID != ROLES.ADMINISTRATOR_IS_ID || USERINFO.Role.ID != ROLES.ADMINISTRATOR_HOLDING_ID) &&
                              <MenuItem value={ROLES.ADMINISTRATOR_AZIENDA_ID} primaryText={ROLES.ADMINISTRATOR_AZIENDA_NOME}/> 
                          }
                          { this.state.showAddModify.data.IDHolding != null && this.state.showAddModify.data.IDAzienda != null &&
                              <MenuItem value={ROLES.OPERATOR_ID}              primaryText={ROLES.OPERATOR_NOME}/> 
                          }
                    </SelectField>
                  </Col>
                </Row>
              </Grid>
            }

            { this.state.showAddModify.cheked && 
              <div>
                <div style={{textAlign: "center", margin: "20px"}}>{LABEL_DIALOG_UserNew_Payment[USERLANGUAGE]}</div>
                <div style={{margin: "0 auto", width: "fit-content"}}>
                    <PaypalExpressBtn 
                        env       = {this.props.paypalConfig.Environment} 
                        client    = {this.props.paypalConfig.Client}
                        currency  = {this.props.paypalPrice.Valuta}
                        total     = {this.props.paypalPrice.Prezzo}
                        onError   = {this.onPaymentError}
                        onSuccess = {this.onPaymentSuccess}
                        onCancel  = {this.onPaymentCancel} />
                </div>
              </div>
              
            }
          </Dialog>
        </div>
      </div>;
  }
}

function mapStateToProps(state) {
  const { operatoreReducer } = state;
  const { isFetching, isAuthenticated, holdingList, usernameAssociaError, aziendeList, operatoriList, toRefreshOnRender, errorMessage, showAddOperatoreDialog, errorAddOperatoreUsername, usernameError, userEmailError, errorAddOperatoreEmail, paypalConfig, paypalPrice } = operatoreReducer;
  return {
    isFetching,
    holdingList,
    aziendeList,
    operatoriList,
    isAuthenticated,
    toRefreshOnRender,
    errorMessage,
    showAddOperatoreDialog,
    errorAddOperatoreUsername,
    errorAddOperatoreEmail,
    paypalConfig,
    paypalPrice,
    usernameError,
    userEmailError,
    usernameAssociaError
  };
}


export default connect(mapStateToProps)(Operatori);


// WEBPACK FOOTER //
// ./src/Containers/Operatori.js